/* Popup Email — open/close, overlay + Escape dismissal, focus trap and
   focus restore. Delegated from document so the trigger keeps working
   after the buy-buttons block re-renders on a variant change. */
(function () {
  var POPUP_SELECTOR = '[data-fc-notify-popup]';
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  if (window.fcNotifyPopupBound) return;
  window.fcNotifyPopupBound = true;

  /* Backstop for the exit transition — if transitionend never lands (the
     tab was backgrounded, the transition was interrupted) the popup still
     gets hidden and focus still gets restored. */
  var CLOSE_FALLBACK_MS = 400;

  var lastFocused = null;
  var closeTimer = null;

  /* A trigger names its popup by id (the product cards all point at the one
     shared popup); one that names none is the PDP's own button, which wants
     the product-specific popup rendered by the section — never the shared
     one, which sits on the same page and can come first in the DOM. */
  function getPopup(trigger) {
    var id = trigger && trigger.getAttribute('data-fc-notify-open');
    if (id) return document.getElementById(id);
    return (
      document.querySelector(POPUP_SELECTOR + ':not([data-fc-notify-shared])') ||
      document.querySelector(POPUP_SELECTOR)
    );
  }

  function getOpenPopup() {
    return document.querySelector(POPUP_SELECTOR + '[data-fc-notify-state="open"]');
  }

  function field(popup, name) {
    return popup.querySelector('[data-fc-notify-field="' + name + '"]');
  }

  /* Text (or an attribute) plus the hidden flag in one go, so a product that
     has no badge/colour/sale price leaves no empty box behind from whichever
     product the popup was last opened for. */
  function setField(popup, name, value, attribute) {
    var el = field(popup, name);
    if (!el) return false;

    if (value) {
      if (attribute) el.setAttribute(attribute, value);
      else el.textContent = value;
      el.hidden = false;
    } else {
      if (attribute) el.removeAttribute(attribute);
      else el.textContent = '';
      el.hidden = true;
    }

    return !!value;
  }

  /* The shared popup carries no product of its own — the card that was
     clicked hands one over on data attributes. Everything here is written as
     text or as a discrete attribute, never as markup. */
  function fillShared(popup, trigger) {
    if (!popup.hasAttribute('data-fc-notify-shared') || !trigger) return;

    var data = trigger.dataset;

    var image = field(popup, 'image');
    if (image) {
      if (data.fcNotifyImage) {
        image.src = data.fcNotifyImage;
        image.alt = data.fcNotifyImageAlt || data.fcNotifyTitle || '';
        image.hidden = false;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
      }
    }

    setField(popup, 'badge', data.fcNotifyBadge);
    setField(popup, 'title', data.fcNotifyTitle);

    var hasFeature = setField(popup, 'feature', data.fcNotifyFeature);
    var hasColor = setField(popup, 'color', data.fcNotifyColor);
    var colorEl = field(popup, 'color');
    if (colorEl) {
      if (data.fcNotifyColorBadge) colorEl.style.backgroundColor = data.fcNotifyColorBadge;
      else colorEl.style.removeProperty('background-color');
    }
    var featureColor = field(popup, 'featureColor');
    if (featureColor) featureColor.hidden = !hasFeature && !hasColor;

    setField(popup, 'price', data.fcNotifyPrice);
    var hasCompare = setField(popup, 'compare', data.fcNotifyCompare);
    var price = field(popup, 'price');
    if (price) price.classList.toggle('on-sale', hasCompare);

    /* Without this Klaviyo has nothing to watch — the subscribe handler
       refuses the submit rather than posting an alert that can never fire. */
    var form = popup.querySelector('[data-ts-subscribe]');
    if (form) form.setAttribute('data-ts-subscribe-variant', data.fcNotifyVariant || '');
  }

  /* One popup serves every card, so a signup for the last product must not
     still be showing its success state when the next one opens. */
  function resetForm(popup) {
    var form = popup.querySelector('[data-ts-subscribe]');
    if (!form) return;

    form.classList.remove('is-loading', 'is-submitted');

    var success = form.querySelector('[data-ts-subscribe-success]');
    if (success) success.classList.remove('is-success');
    var error = form.querySelector('[data-ts-subscribe-error]');
    if (error) error.classList.remove('is-error');

    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = false;

    setTermsInvalid(form, false);
  }

  function isOpen(popup) {
    return !!popup && popup.dataset.fcNotifyState === 'open';
  }

  function open(popup) {
    if (!popup || isOpen(popup)) return;

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    } else {
      /* Only remember the trigger on a fresh open — reopening mid-close
         would otherwise overwrite it with something inside the popup. */
      lastFocused = document.activeElement;
    }

    popup.classList.remove('is-closing');
    popup.removeAttribute('hidden');
    /* Reading a layout property flushes the display:none -> block change,
       so the browser has a start value to transition from. Without it the
       dialog snaps straight to its open state. */
    void popup.offsetWidth;
    popup.classList.add('is-open');
    popup.dataset.fcNotifyState = 'open';
    document.body.classList.add('fc-notify-popup-open');

    var first =
      popup.querySelector('.fc-notify-popup__input') ||
      popup.querySelector(FOCUSABLE);
    if (first) first.focus();
  }

  function finishClose(popup) {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    popup.classList.remove('is-closing');
    popup.setAttribute('hidden', '');
    popup.dataset.fcNotifyState = 'closed';
    document.body.classList.remove('fc-notify-popup-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  function close(popup) {
    if (!isOpen(popup)) return;

    popup.dataset.fcNotifyState = 'closing';
    popup.classList.remove('is-open');
    popup.classList.add('is-closing');

    var dialog = popup.querySelector('.fc-notify-popup__dialog');

    function onEnd(event) {
      if (event.target !== dialog || event.propertyName !== 'opacity') return;
      dialog.removeEventListener('transitionend', onEnd);
      finishClose(popup);
    }

    if (dialog) dialog.addEventListener('transitionend', onEnd);

    closeTimer = setTimeout(function () {
      if (dialog) dialog.removeEventListener('transitionend', onEnd);
      closeTimer = null;
      finishClose(popup);
    }, CLOSE_FALLBACK_MS);
  }

  function setTermsInvalid(form, invalid) {
    if (!form) return;
    var label = form.querySelector('.fc-notify-popup__terms');
    var input = form.querySelector('.fc-notify-popup__terms-input');
    var error = form.querySelector('.fc-notify-popup__terms-error');

    if (label) label.classList.toggle('is-invalid', invalid);
    if (input) input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    if (!error) return;
    if (invalid) error.removeAttribute('hidden');
    else error.setAttribute('hidden', '');
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var trigger = event.target.closest('[data-fc-notify-open]');
    if (trigger) {
      event.preventDefault();

      var popup = getPopup(trigger);
      if (!popup) return;

      /* Rebuilt on every open, not once: the next card to use this popup is
         a different product with a different variant to watch. */
      if (popup.hasAttribute('data-fc-notify-shared')) {
        fillShared(popup, trigger);
        resetForm(popup);
      }

      open(popup);
      return;
    }

    var closer = event.target.closest('[data-fc-notify-close]');
    if (closer) {
      event.preventDefault();
      close(closer.closest(POPUP_SELECTOR));
    }
  });

  /* The terms box has no `required` attribute (see the comment on it above),
     so this is what stops an un-ticked submit. Registered as a validator on
     the shared subscribe handler rather than as a second document-level
     submit listener, so it cannot end up running after the request has
     already gone out — listener order between the two scripts is not
     guaranteed. Email validity is still checked natively and runs first. */
  window.tsSubscribeValidators = window.tsSubscribeValidators || [];
  window.tsSubscribeValidators.push(function (form) {
    if (!form.classList || !form.classList.contains('fc-notify-popup__form')) return true;

    var terms = form.querySelector('.fc-notify-popup__terms-input');
    if (!terms || terms.checked) return true;

    setTermsInvalid(form, true);
    terms.focus();
    return false;
  });

  document.addEventListener('change', function (event) {
    var terms = event.target;
    if (!terms.classList || !terms.classList.contains('fc-notify-popup__terms-input')) return;
    if (terms.checked) setTermsInvalid(terms.form, false);
  });

  document.addEventListener('keydown', function (event) {
    var popup = getOpenPopup();
    if (!isOpen(popup)) return;

    if (event.key === 'Escape') {
      close(popup);
      return;
    }

    if (event.key !== 'Tab') return;

    /* Queried on each Tab because the form swaps between its input state
       and the success/error state after a post. */
    var focusables = Array.prototype.filter.call(
      popup.querySelectorAll(FOCUSABLE),
      function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      }
    );
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
